import { Pipe, PipeTransform } from '@angular/core';
import { WorkAbsence } from '../_generated/work-rest-api';

@Pipe({name: 'getIconForTimerecordType'})
export class AxApiGetIconForTimerecordType implements PipeTransform {
  transform(absence: WorkAbsence) {
    switch (absence.timerecordtypeId) {
      case 3:
        return 'assets/svg-icons/military.svg';
      case 6:
        return 'assets/svg-icons/health.svg';
      case 7:
        return 'assets/svg-icons/accident.svg';
      default:
        return 'assets/svg-icons/holidays.svg';
    }
  }
}
